import { Rule } from 'antd/lib/form';

export const email: Rule[] = [
  {
    required: true,
    message: 'O e-mail é obrigatório',
  },
  {
    type: 'email',
    message: 'O e-mail informado não é válido',
  },
];
